import { SimpleGrid } from '@chakra-ui/react';
import { Button, Typography } from '@sgi/gravity';
import { SearchDriverByCustomerNumberDetailDto } from 'src/types/DriverHubBFFOpenAPI';
import { Fragment } from 'react';

interface Props {
  customers: SearchDriverByCustomerNumberDetailDto[];
  onSelectCustomer: (customerId: string) => void;
}

export const CustomerSearchResults = ({ customers, onSelectCustomer }: Props) => {
  return (
    <SimpleGrid columns={5} gap={4}>
      <Typography variant="bodyBold">Customer #</Typography>
      <Typography variant="bodyBold">Last Name</Typography>
      <Typography variant="bodyBold">First Name</Typography>
      <Typography variant="bodyBold">Birthdate</Typography>
      <Typography variant="bodyBold"> </Typography>

      {customers.length === 0 ? (
        <Typography>No Results Found.</Typography>
      ) : (
        customers.map(customer => (
          <Fragment key={customer.customerNumber}>
            <Typography>{customer.customerNumber}</Typography>
            <Typography>{customer.lastName}</Typography>
            <Typography>{customer.firstName}</Typography>
            <Typography>{customer.dateOfBirth?.toString().substring(0, 10)}</Typography>
            <Button onClick={() => onSelectCustomer(customer.customerNumber.toString())} size="sm">
              Select
            </Button>
          </Fragment>
        ))
      )}
    </SimpleGrid>
  );
};
